export default "__VITE_ASSET__71c8ec36__"